module.exports = __webpack_public_path__ + "img/6.52a32785.jpg";